"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const d3 = require("d3");
const music_visualization_1 = require("./music-visualization");
const types_1 = require("./types");
class Graph extends music_visualization_1.MusicVisualization {
    constructor(element, onClick) {
        super(element, { top: 0, bottom: 0, left: 0, right: 0 }, false, true, false, onClick);
        this.simulation = d3.forceSimulation()
            .force("x", d3.forceX())
            .force("y", d3.forceY())
            .force("link", d3.forceLink().distance(50)) //.strength(1))
            .force("charge", d3.forceManyBody().strength(-70));
    }
    updateDataRepresentation() {
        this.addNodeShapes(types_1.Circle);
        this.addEdgeLines();
        this.addDragging();
        this.simulation
            .force("center", d3.forceCenter(this.width / 2, this.height / 2))
            .nodes(this.data.nodes)
            .on("tick", () => {
            this.updateShapePositions();
            this.updateLinePositions();
        })
            .force("link").links(this.data.edges);
    }
    addDragging() {
        this.getNodeShapes()
            .call(d3.drag()
            .on("start", (d) => {
            if (!d3.event.active)
                this.simulation.alphaTarget(1).restart();
            d.fx = d.x;
            d.fy = d.y;
        })
            .on("drag", (d) => {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
        })
            .on("end", (d) => {
            if (!d3.event.active)
                this.simulation.alphaTarget(0);
            d.fx = null;
            d.fy = null;
        }));
    }
}
exports.Graph = Graph;



//////////////////
// WEBPACK FOOTER
// ./~/music-visualization/lib/graph.js
// module id = 1746
// module chunks = 3